import * as React from 'react'
import { cn } from '@/lib/utils'

const Layout = (props) => (
  <div
    className="max-h-screen min-h-screen w-full overflow-hidden"
    {...props}
  />
)
Layout.displayName = 'Layout'

const Header = React.forwardRef((props, ref) => (
  <div
    ref={ref}
    className="z-10 flex h-[var(--header-height)] w-full items-center space-x-4 bg-card p-4 px-8 shadow"
    {...props}
  />
))
Header.displayName = 'Header'

const Body = ({ className, ...props }) => (
  <div
    className={cn(
      'h-[calc(100vh-var(--header-height))] overflow-y-auto px-[--body-padding-x] py-[--body-padding-y]',
      className,
    )}
    {...props}
  />
)
Body.displayName = 'Body'

Layout.Header = Header
Layout.Body = Body

export { Layout }
